<template>
    <div class="container">
        <div class="section" v-for="(item,index) in sectionData" :key="index" :class="{'btn-section':item.type === 'btn'}">
            <img v-lazy="item.url" alt=""  v-if="item.type === 'img' || item.type === 'btn'" :class="{'btn-style':item.type==='btn'}"
                @click="clickImage(item.type)"
            >
            <!-- 轮播 -->
            <div class="sw-section" v-if="item.type==='swiper'">
                <div class="swiper-container wrap">
                    <div class="swiper-wrapper">
                        <div v-for="item in swiperList"  class="swiper-slide" :key="item">
                            <img :src="item" >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer" @click="toBuy('立即咨询')">
            <img src="https://s21.lgstatic.com/growth/activity/20211104/1636013497720.png" alt="">
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                sectionData:[
                    {url:'https://s21.lgstatic.com/growth/activity/20211104/1635994567120.png',type:'img'},
                    {url:'https://s20.lgstatic.com/growth/activity/20211104/1635994598185.png',type:'img'},
                    {url:'',type:'swiper'},
                    {url:'https://s20.lgstatic.com/growth/activity/20211104/1635994689156.png',type:'img'},
                    {url:'https://s21.lgstatic.com/growth/activity/20211117/1637140451491.jpeg',type:'img'},
                    {url:'https://s20.lgstatic.com/growth/activity/20211104/1635994733416.png',type:'btn'},
                    {url:'https://s20.lgstatic.com/growth/activity/20211105/1636080979181.png',type:'img'},
                    {url:'https://s21.lgstatic.com/growth/activity/20211104/1635994768981.png',type:'img'},
                    {url:'https://s21.lgstatic.com/growth/activity/20211104/1635994805267.png',type:'img'}
                ],
                swiperList:[
                    'https://s21.lgstatic.com/growth/activity/20211104/1635995129216.png',
                    'https://s20.lgstatic.com/growth/activity/20211104/1635995155048.png',
                    'https://s20.lgstatic.com/growth/activity/20211104/1635995173866.png',
                    'https://s20.lgstatic.com/growth/activity/20211104/1635995186115.png'
                ]
            }
        },
        mounted () {
            this.renderSwiper();
            setTimeout(()=>{
                this.eduPlatTrack('WebView', { page_id: 'c1tc6'});
            },200);
        },
        methods: {
            toBuy(name) {
                this.eduPlatTrack('WebButtonClick', {
                    'page_id': 'c1tc6',
                    'button_name': name
                });
                setTimeout(() => {
                    location.href= "https://kaiwu.lagou.com/crmForm/form/bb9e0d0e08dd4008a967df3bab29951e";
                }, 200);
            },
            clickImage(type){
                if(type==='btn'){
                    this.toBuy('了解更多项目详情');
                }
            },
            renderSwiper() {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.wrap', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    watchSlidesProgress: true,
                    // prevButton: '.swiper-button-prev',
                    // nextButton: '.swiper-button-next',
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });

                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 300 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            },
        },
    }
</script>

<style lang="less" scoped>
    .container{
        user-select: none;
        width: 100%;
        background: #FFF4E9;
        padding-bottom: 80PX;
        .btn-section{
            text-align: center;
        }
        .section{
            margin: 0 auto;
            width: 100%;
            img{
                width: 100%;
            }
            .btn-style{
                height: 80PX;
                width: auto;
                cursor: pointer;
            }
        }
        .module-container{
            width: 68%;
        }
        .footer{
            width: 100%;
            position: fixed;
            bottom: -10PX;
            left: 0;
            cursor: pointer;
            z-index: 10;
            img{
                width: 100%;
            }
        }
        .sw-section {
            width: 100%;
            padding: 30PX 0 30PX;
            /deep/ .wrap {
                width: 1200PX;
                height: 410PX;
                .swiper-slide {
                    width: 582PX;
                    opacity: 0;
                    img {
                        display: block;
                        width: 582PX;
                        margin: 0 auto;
                    }
                    &.swiper-slide-active {
                        opacity: 1;
                    }
                    &.swiper-slide-next, &.swiper-slide-prev {
                        opacity: .5;
                    }
                }
                .swiper-pagination {
                    bottom: 0PX;
                }
                .swiper-pagination-bullet{
                    width: 10PX;
                    height: 10PX;
                    background: linear-gradient(312deg, #7C1C33 0%, #1E1C54 100%);
                    border-radius: 50%;
                    opacity: .5;
                    &-active{
                        border-radius: 12PX;
                        width: 24PX;
                        background: linear-gradient(312deg, #7C1C33 0%, #1E1C54 100%);
                        opacity: 1;
                    }
                }
            }
        }
    }
</style>